import React from "react";
import "./Affiliates.css";
import MKF from "../../../assets/images/affiliates/MKF_HORIZONTAL_BLACK.png";
import UnderdogFantasy from "../../../assets/images/affiliates/Underdog_Black_Font.png";
import PrizePicks from "../../../assets/images/affiliates/prize-picks.jpg";

export default function Affiliates() {
  return (
    <div className="affiliates-container">
      <h1>Affiliates</h1>
      <p>We are happy to be affiliated with these fine folks.</p>
      <hr />
      <div>
        <img
          src={PrizePicks}
          alt="Prize Picks Logo"
          style={{ width: "50%", marginBottom: "-25px" }}
        />
        <br />
        <br />
        <p>
          Sign-up for <strong>Prize Picks</strong> today. Use promo code:{" "}
          <strong>GUP</strong> and get a 100% match up to $100.
        </p>
        <a
          href="https://app.prizepicks.com/sign-up?invite_code=GUP"
          target="_blank"
          rel="noreferrer"
        >
          Sign up today!
        </a>
      </div>
      <hr />

      <div>
        <img
          src={UnderdogFantasy}
          alt="Underdog Fantasy Logo"
          style={{ width: "40%", marginBottom: "-25px" }}
        />
        <p>
          Sign-up for <strong>Underdog Fantasy</strong> today. Use promo code:{" "}
          <strong>GUP</strong> and get a 100% match up to $100.
        </p>
        <a
          href="https://play.underdogfantasy.com/p-gups-corner"
          target="_blank"
          rel="noreferrer"
        >
          Sign up today!
        </a>
      </div>
      <hr />
      <div className="affiliates-entry">
        <img
          src={MKF}
          alt="Monkey Knife Fight Logo"
          style={{ maxWidth: "90%" }}
        />
        <p>
          Sign-up for <strong>Monkey Knife Fight</strong> today and put your
          money where your mouth is. Use promo code: <strong>GUPS</strong> when
          you make your first deposit and you’ll receive 100% on your first
          deposit up to $100.
        </p>
        <a href="http://wlmonkeyknifefight.adsrv.eacdn.com/C.ashx?btag=a_1204b_213c_&affid=1117&siteid=1204&adid=213&c=">
          Sign up today!
        </a>
      </div>
    </div>
  );
}
